
import {markRaw} from 'vue'
import {ROLES} from './playground-defs'
export default {
  emits: ['toggle-add', 'add'],
  data(){
    return {
      visible: false,
      ROLES: markRaw(ROLES)
    }
  },
}
